import React from "react";
import { Dropdown, Avatar, Typography, Modal } from "antd";
import { useDispatch } from "react-redux";
import {
  ExclamationCircleOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import NavItem from "./NavItem";
import Flex from "components/shared-components/Flex";
import styled from "@emotion/styled";
import { FONT_WEIGHT, MEDIA_QUERIES, SPACER } from "constants/ThemeConstant";
import { signOut } from "store/slices/authSlice";
import { autoLogout } from "services/LogoutService";
import { APP_PREFIX_PATH, USER_SESSION_CONFIG } from "configs/AppConfig";
import { useGetProfile } from "UserProfileContext";

const { Paragraph } = Typography;

const Profile = styled.div(() => ({
  display: "flex",
  alignItems: "center",
}));

const UserInfo = styled("div")`
  padding-left: ${SPACER[2]};

  @media ${MEDIA_QUERIES.MOBILE} {
    display: none;
  }
`;

const MenuItem = (props) => (
  <Flex as="a" href={props.path} alignItems="center" gap={SPACER[2]}>
    {props.icon}
    <span>{props.label}</span>
  </Flex>
);

const MenuItemSignOut = (props) => {
  const dispatch = useDispatch();

  const handleSignOut = () => {
    dispatch(signOut());
    autoLogout();
  };

  const confirmLogout = () => {
    Modal.confirm({
      title: "Logout?",
      icon: <ExclamationCircleOutlined />,
      content: "Apakah Anda yakin keluar aplikasi?",
      okText: "Ya",
      cancelText: "Batal",
      onOk() {
        handleSignOut();
      },
      okButtonProps: {
        className: "border-color-danger bg-none text-danger",
      },
    });
  };

  return (
    <div onClick={confirmLogout} className="text-danger">
      <Flex alignItems="center" gap={SPACER[2]} data-testid={props.dataTestID}>
        <LogoutOutlined />
        <span>{props.label}</span>
      </Flex>
    </div>
  );
};

const items = [
  {
    key: "profile",

    label: (
      <MenuItem
        label="Profil Saya"
        path={APP_PREFIX_PATH + "/profile"}
        icon={<UserOutlined />}
        dataTestID="menu-navbar-profile"
      />
    ),
  },
  {
    key: "logout",
    label: <MenuItemSignOut label="Logout" dataTestID="menu-navbar-logout" />,
  },
];

const getInitials = (name) => {
  let nameArray = name?.split(" ");

  let initials = nameArray?.map((word) => word[0]).join("");

  return initials?.toUpperCase();
};

export const NavProfile = ({ mode }) => {
  const profile = useGetProfile();
  return (
    <Dropdown
      placement="bottomRight"
      menu={{ items }}
      trigger={["click"]}
      data-testid="btn-navbar-profile"
    >
      <NavItem mode={mode}>
        {profile && (
          <Profile>
            <Avatar
              style={{
                backgroundColor: "#f56a00",
                verticalAlign: "middle",
              }}
            >
              {getInitials(profile?.name)}
            </Avatar>
            <UserInfo className="profile-text show-desktop">
              <Paragraph
                className="w-100 mb-0 text-white"
                style={{ maxWidth: "160px", fontWeight: FONT_WEIGHT.SEMIBOLD }}
                ellipsis={{
                  rows: 1,
                  expandable: false,
                }}
              >
                {profile?.nama}
              </Paragraph>
              <Paragraph
                className="w-100 mb-0 text-white"
                style={{ maxWidth: "160px", opacity: 0.8 }}
                ellipsis={{
                  rows: 1,
                  expandable: false,
                }}
              >
                {profile?.username}
              </Paragraph>
            </UserInfo>
          </Profile>
        )}
      </NavItem>
    </Dropdown>
  );
};

export default NavProfile;
